/**
 * Zone color legend — same color assignment as the plan tint
 * (../mep/zones keeps them in sync by construction).
 */
import type { MepZone } from "../api/types";
import { zoneLegend } from "../mep/zones";

export function ZoneLegend({ zones }: { zones: MepZone[] }) {
  if (zones.length === 0) {
    return (
      <p data-testid="zones-empty" style={{ color: "#8e8eb8" }}>
        No zones yet.
      </p>
    );
  }
  return (
    <div
      data-testid="zone-legend"
      style={{ display: "flex", gap: "0.8rem", flexWrap: "wrap", fontSize: "0.8rem" }}
    >
      {zoneLegend(zones).map(({ zone, color }, i) => (
        <span
          key={zone.id}
          data-testid="zone-legend-row"
          style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem" }}
        >
          <span
            style={{
              width: 11,
              height: 11,
              borderRadius: 2,
              background: color,
              display: "inline-block",
            }}
          />
          Zone {i + 1} · {zone.space_ids.length} spaces
          {zone.area_m2 !== null && (
            <span style={{ color: "#8e8eb8" }}>({zone.area_m2.toFixed(0)} m²)</span>
          )}
        </span>
      ))}
    </div>
  );
}
